import { AlertCircle } from 'lucide-react';
import { scrollToProduitSection } from '../../utils/produitFormValidation.js';

/**
 * Bandeau footer — explique pourquoi Enregistrer est indisponible (Lot 2).
 */
export default function ProduitSaveBlockers({ issues }) {
  if (!issues?.length) return null;

  return (
    <div className="px-6 py-3 bg-amber-50 border-t border-amber-200">
      <div className="flex items-start gap-2">
        <AlertCircle className="h-5 w-5 text-amber-700 shrink-0 mt-0.5" />
        <div className="min-w-0">
          <p className="text-sm font-medium text-amber-900">
            Pour enregistrer, complétez les éléments suivants :
          </p>
          <ul className="mt-2 space-y-1">
            {issues.map((issue) => (
              <li key={issue.id}>
                <button
                  type="button"
                  onClick={() => scrollToProduitSection(issue.sectionKey)}
                  className="text-sm text-amber-800 hover:text-amber-950 underline text-left"
                >
                  {issue.message}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
